import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-feed-document',
  templateUrl: './feed-document.component.html',
  styleUrls: ['./feed-document.component.scss']
})
export class FeedDocumentComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<FeedDocumentComponent>, @Inject(MAT_DIALOG_DATA) public data:any) { }
  
  ngOnInit(): void {
    
  }
  dialogClose(){

    this.dialogRef.close()
    
  }

  isImage(type: string): boolean {
    const imageTypes = [
      'image/jpeg',
      'image/png',
      'image/gif',
      'image/webp',
      'image/jpg',
      'image/bmp',
      'image/svg+xml',
      'image/tiff',
      'image/x-icon',
      'image/heic',
      'image/heif'
    ];
    return imageTypes.includes(type.toLowerCase());

  }

  isDocument(type: string): boolean {
  const documentTypes = [
    'application/pdf',
    'application/msword', // .doc
    'document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'application/vnd.ms-excel', // .xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'application/vnd.ms-powerpoint', // .ppt
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
    'text/plain', // .txt
    'application/rtf', // .rtf
    'application/vnd.oasis.opendocument.text', // .odt
    'application/vnd.oasis.opendocument.spreadsheet', // .ods
    'application/vnd.oasis.opendocument.presentation' // .odp
  ];
  return documentTypes.includes(type.toLowerCase());
}

}
